/**
 * TEC-489 Application Autofill's feature-flag cookie name, single-sourced so the backoffice
 * registry, the client entry point, and the server-side route gate all agree. Managed from
 * `/backoffice/experiments` (see feature-flag-registry.ts) on the shared cookie mechanism in
 * read-feature-flag.ts.
 */
export const APPLY_AUTOFILL_COOKIE = 'dev_enable_apply_autofill';
